import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import sortBy from 'lodash/sortBy';

import { getSampleDownloadUrl } from 'Api/Product/product-service';
import formatFileSize from 'Helpers/Format/FormatFileSize';
import SampleAudio from 'Components/Utility/Sample/SampleAudio';
import SampleVideo from 'Components/Utility/Sample/SampleVideo';

const videoFormats = ['mp4'];
const audioFormats = ['wav', 'mp3', 'wma', 'flac'];

export default function SampleDownloads({ download: { files } }) {
  if (files.every(file => audioFormats.includes(file.format))) {
    return <SampleAudio files={files} />;
  }
  if (files.every(file => videoFormats.includes(file.format))) {
    return <SampleVideo files={files} />;
  }

  const downloadFile = async (file) => {
    const { signedGetUrl, key } = await getSampleDownloadUrl(file._id);

    const link = document.createElement('a');
    link.download = key.split('.').slice(1).join('.');
    link.target = '_blank';
    link.href = signedGetUrl;

    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false,
    });

    link.dispatchEvent(clickEvent);
  };

  const sortedFiles = sortBy(files, ['format']);

  return (
    <div className="sample-buttons">
      {sortedFiles.map(file => (
        <Button
          size="sm"
          key={file._id}
          color="primary"
          title={`MD5 Hash - ${file.md5}`}
          onClick={() => downloadFile(file)}
        >
          {file.format.toUpperCase()} - {formatFileSize(file.size)}
        </Button>
      ))}
    </div>
  );
}

SampleDownloads.propTypes = {
  download: PropTypes.shape({}).isRequired,
};
